import doc                        from '@widesk-core/decorators/doc';
import model                      from '@widesk-core/decorators/model';
import NetworkServiceModel        from '@/models/NetworkServiceModel';
import ContactModel               from './ContactModel';
import RelationRequestStatusModel from './RelationRequestStatusModel';
import OwnerUserModel             from './OwnerUserModel';

@model.urnResource('relation_request')
@doc.path('/relation_requests/{?id}')
export default class RelationRequestModel extends NetworkServiceModel {
	private declare _tsFilters: {
		"id": id;
		"ownerUser": id;
		"contact": id;
		"relationRequestStatus": id;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};

	@doc.model(OwnerUserModel) declare requester: OwnerUserModel;
	@doc.model(ContactModel) declare contact: ContactModel;
	@doc.model(RelationRequestStatusModel) declare relationRequestStatus: RelationRequestStatusModel;
	@doc.string declare email: string;

}